import React, {useContext} from "react";
import { DappContextProvider } from "../../contexts/MintContext";
import { NetworkErrorMessage } from "./NetworkErrorMessage";
import { NoWalletDetected } from "./NoWalletMessage";
import { TransactionErrorMessage } from "./TransactionErrorMessage";
import { WalletConnected } from "./ConnectedMessage";

export function Messages(): React.ReactElement {
  const { isMetamaskInstalled, networkError, userAddress, transactionError } = useContext(DappContextProvider);

  if(!isMetamaskInstalled){
    return <NoWalletDetected />
  }

  if(networkError){
    return <NetworkErrorMessage />
  }

  if(transactionError) {
    return <TransactionErrorMessage />
  }

  if(userAddress === undefined) {
    return (
      <div className="connection-message"> Please connect wallet. </div>
      )
    } else {
    return (
      <WalletConnected />
    )
  }


}
